import r2wc from '@r2wc/react-to-web-component';
import Masthead from "../../components/Masthead/MastheadComp";

const EmMasthead = r2wc(Masthead, {
  props: {
    data: "json",
    testId: 'string',
    autoplay: "boolean",
    delay: "number",
    size: 'string',
    backgroundwhite: 'boolean'
  },
});
customElements.define("em-masthead", EmMasthead);